<template>
  <div class="home-bar">
    <svg width="8" height="9" viewBox="0 0 8 9" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect y="0.872559" width="1.00133" height="7.98728" fill="#B8B8B8"/>
      <rect x="3.00488" y="0.872559" width="1.00133" height="7.98728" fill="#B8B8B8"/>
      <rect x="6.00977" y="0.872559" width="1.00133" height="7.98728" fill="#B8B8B8"/>
    </svg>
    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8.01 7.99"><path d="M5.51,7.99H2.5C1.12,7.99,0,6.87,0,5.49V2.5C0,1.12,1.12,0,2.5,0h3.01C6.89,0,8.01,1.12,8.01,2.5v2.99c0,1.38-1.12,2.5-2.5,2.5ZM2.5,1c-.83,0-1.5,.67-1.5,1.5v2.99c0,.83,.67,1.5,1.5,1.5h3.01c.83,0,1.5-.67,1.5-1.5V2.5c0-.83-.67-1.5-1.5-1.5H2.5Z" style="fill:#b8b9b9;"/></svg>
    <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M5.23905 0.698097L4.52295 -3.27335e-06L0.482031 4.11826L0.0227875 4.56611L0.0326887 4.57621L0.0230198 4.58606L0.464887 5.01682L4.52196 9.15292L5.23794 8.4547L1.43366 4.57632L5.23905 0.698097Z" fill="#B8B8B8"/>
    </svg>

  </div>
</template>

<style lang="scss" scoped>

.home-bar {
  background-color: #FFFFFF;
  height: 33px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;

  svg:nth-child(2) {
    margin: 0 50px;
  }
}


</style>